import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-construction',
  templateUrl: './construction.component.html',
  styleUrls: ['./construction.component.css']
})
export class ConstructionComponent implements OnInit {
  faculty_image: any
  CONSTRUCTION_ABOUT: any
  CONSTRUCTION_NAME: any
  subdetailslist: any[]
  galleryArry: any
  id
  showView = false
  activeSection = 'about'
  CONSTRUCTIONObj: any
  galleryConfig: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.constr-gallery-pagination',
      clickable: true,
    },
  }
  constructor(private rest: RestService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    window.scrollTo(0, 0)
    // On a construction subdomain (e.g. isc.aoa.edu.eg) the hostname is the
    // source of truth; otherwise fall back to the id in the route.
    const hostId = this.rest.getConstructionIdByHost()
    this.id = hostId ? hostId : this.route.snapshot.paramMap.get('id')
    // The Quality Assurance Center (id 11) has its own dedicated page.
    if (String(this.id) === '11') {
      this.router.navigateByUrl('/eqac')
      return
    }
    this.getConstrction()
  }

  // Smooth-scroll to a section. We don't rely on plain href="#id" anchors:
  // the app uses path-based routing without anchorScrolling, so those don't
  // scroll reliably, and the sticky nav would hide the heading without the
  // scroll-margin-top set in CSS.
  scrollToSection(id: string, event?: Event) {
    if (event) { event.preventDefault() }
    this.activeSection = id
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  getConstrction() {
    this.rest.getConstrction(this.id).subscribe((res: any) => {
      this.CONSTRUCTIONObj = res
      if (res.CONSTRUCTION_NAME == "وحدة ضمان الجودة") {
        this.showView = false
      } else {
        this.faculty_image = res.CONSTRUCTION_IMG_PATH
        this.CONSTRUCTION_ABOUT = res.CONSTRUCTION_ABOUT
        this.CONSTRUCTION_NAME = res.CONSTRUCTION_NAME
        this.subdetailslist = res.subdetailslist
        this.galleryArry = res.gallery
        this.showView = true
        this.scrollToFragment()
      }
    })
  }

  // When navigating here from the news/events tab bar (e.g. .../constrction/7#sections)
  // scroll to that section once it has rendered.
  private scrollToFragment() {
    const fragment = this.route.snapshot.fragment
    if (!fragment) { return }
    this.activeSection = fragment
    setTimeout(() => {
      const el = document.getElementById(fragment)
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }) }
    }, 150)
  }

  // True when a value is a real, non-empty string. The API returns "" / null and
  // sometimes a lone "." placeholder (e.g. empty English fields) — treat those as empty.
  has(value): boolean {
    if (!value) { return false }
    const v = String(value).trim()
    return v.length > 0 && v !== '.'
  }

  // Heading like "نبذة عن المتحف": the API type ("متحف") with the definite
  // article prefixed, falling back to "المنشأة" when no type is provided.
  aboutTitle(): string {
    const type = this.CONSTRUCTIONObj?.TYPE_TITLE
    if (!this.has(type)) { return 'المنشأة' }
    const value = String(type).trim()
    return value.startsWith('ال') ? value : 'ال' + value
  }

  // True when at least one social/site link is present.
  hasSocial(): boolean {
    const o = this.CONSTRUCTIONObj
    if (!o) { return false }
    return this.has(o.CONSTRUCTION_FACEBOOK) || this.has(o.CONSTRUCTION_TWITTER)
      || this.has(o.CONSTRUCTION_INSTAGRAME) || this.has(o.CONSTRUCTION_YOUTUBE)
      || this.has(o.CONSTRUCTION_SITELINK)
  }

  // First letters of the unit head's name, used as an avatar fallback (no image
  // for the head of unit is returned by the API yet).
  personInitials(): string {
    const name = this.CONSTRUCTIONObj?.ACT_PERSON_NAME
    if (!this.has(name)) { return '' }
    return String(name).trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('')
  }

  src_image: any = ''
  openImage(src) {
    this.src_image = src
  }

  // Delegated on the swiper container so it also catches clicks on looped clone
  // slides (Swiper clones them with cloneNode, which drops Angular listeners).
  onGalleryClick(event) {
    const item = (event.target as HTMLElement).closest('.constr-gallery-item')
    const img = item && item.querySelector('img')
    if (img) {
      this.src_image = (img as HTMLImageElement).src
    }
  }
}
